import { getIn18Text } from 'api';
import React, { useEffect, useState, useCallback, useRef, useMemo, useImperativeHandle } from 'react';
import { Input, Spin, ConfigProvider, Alert } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import { debounce, keyBy } from 'lodash';
import { EmptyList } from '../../components/empty/empty';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { SiriusProductLinkImportDrawer, UniDrawerModuleId, showUniDrawer } from '@lxunit/app-l2c-crm';
import style from './style.module.scss';
import useTableDataLoader from '../../hooks/useTableDataLoader';
import { getColumns } from './column';
import { ReactComponent as CloseSvg } from '@/images/icons/edm/close.svg';
import { ProductSampleModal } from '../productSampleModal/productSampleModal';
import { ProductPreviewModal } from '../productPreviewModal/productPreviewModal';
import SearchIcon from '@web-common/components/UI/Icons/svgs/SearchSvg';
import toast from '@web-common/components/UI/Message/SiriusMessage';
import SiriusTable from '@lingxi-common-component/sirius-ui/Table';
import SiriusPagination from '@lingxi-common-component/sirius-ui/Pagination';
import { apiHolder as api, apis } from 'api';
import { useAppSelector, MailProductActions, useActions } from '@web-common/state/createStore';
import EllipsisTooltip from '@/components/Layout/Customer/components/ellipsisTooltip/ellipsisTooltip';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import { ReactComponent as AddIcon } from '@/images/icons/website/tongyong_tianjia.svg';
import { ReactComponent as LianjieIcon } from '@/images/icons/website/tongyong_lianjie.svg';
import Tooltip from '@lingxi-common-component/sirius-ui/Tooltip';
import { OtherColorOptions, ProductAttrOptions } from '../productUpdateColumnModal/productUpdateColumnModal';
import { getTransText } from '@/components/util/translate';
import ProductEmpty from '../productEmpty';
import { TongyongZhankaiXia, TongyongZhankaiYou, TongyongShuaxin, TongyongYiwen } from '@sirius/icons';
import { SidebarGuideCompment } from '@web-edm/components/editor/SidebarGuideComp/sidebarGuideComp';
import { ContentProduct } from '@web-edm/send/contentRoot';
import classNames from 'classnames';
const productApi = api.api.requireLogicalApi(apis.mailProductImplApi);
const siteApi = api.api.requireLogicalApi(apis.siteApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const defaultPageSize = 20;
const businessTypeMap = {
    mail: 'NORMAL',
    EDM: 'MARKETING',
    WA: 'WA',
    BUTTON: '',
};
export const ProductSettingModal = (props) => {
    if (process.env.BUILD_ISLINGXI)
        return null;
    const { fromPage, getContainer, insertGuideEditorName2, setShouldInsertGuideEditorName2, fromProductGuide, config } = props;
    const { inModal = true, isLimitSelectCount = true, onSelectRowsChange = () => { }, showSidebarGuideCompment = true, enableCheckSample = true, showSelectedList = true, tableStyle = {}, contentStyle = {}, tableContentStyle = {}, contentDisable = false, initSelectKeys = [], onFirstLoadDone, showAnalyzeProductByUrl = true, hiddenExampleEntry = false, autoShowProductAddModal = true, showTableWhenProductEmpty = false, emptyText = getIn18Text('ZANWEIZHAODAOSOUSUONEI'), emptyStyle = {}, } = config || {};
    const [currentPage, setCurrentPage] = useState(1);
    const [pagesize, setPagesize] = useState(defaultPageSize);
    const [searchKey, setSearchKey] = useState('');
    const [isComposition, setIsComposition] = useState(false);
    const [onOpen, setOnOpen] = useState(showSidebarGuideCompment ? true : false);
    const isInWAPage = fromPage === 'WA';
    const isInMailAPage = fromPage === 'mail' || fromPage === 'EDM';
    const fieldsMap = useMemo(() => {
        if (!isInMailAPage) {
            return keyBy(ProductAttrOptions.filter(item => item.value !== 'specificationInfo').concat(OtherColorOptions), 'value');
        }
        return keyBy(ProductAttrOptions, 'value');
    }, [isInMailAPage]);
    useEffect(() => {
        let list = getColumns(isInMailAPage);
        setColumnslist(list);
    }, [isInMailAPage]);
    const onSearch = (searchKey) => {
        setCurrentPage(1);
        setSearchParam(Object.assign(Object.assign({}, searchParam), { page: 1, keyword: searchKey }));
    };
    const debounceFn = useCallback(debounce(callback => {
        callback();
    }, 1000), []);
    useEffect(() => {
        if (isComposition) {
            return;
        }
        debounceFn(() => onSearch(searchKey));
    }, [searchKey, isComposition]);
    const imgColumns = useAppSelector(state => state.mailProductReducer.imgColumns);
    const tableColumns = useAppSelector(state => state.mailProductReducer.tableColumns);
    const waColumns = useAppSelector(state => state.mailProductReducer.waColumns);
    const [innerVisible, setInnerVisible] = useState(false);
    const [noEmpty, setNoEmpty] = useState(false);
    const [allTableMap, setAllTableMap] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState(initSelectKeys);
    const [columnslist, setColumnslist] = useState([]);
    const [showSampleModal, setShowSampleModal] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [searchParam, setSearchParam] = useState({
        keyword: '',
        page: 1,
        pageSize: defaultPageSize,
    });
    const [selectedRows, setSelectedRows] = useState([]);
    const siteListRef = useRef([]);
    const [selectSite, setSelectSite] = useState(['']);
    const [imgSize, setImgSize] = useState(150);
    const [imgDisplay, setImgDisplay] = useState('cover');
    const [disableResetData, setDisableResetData] = useState(false);
    const shouldOpenRef = useRef(true);
    const MAX_COUNT = isInWAPage ? 10 : 20;
    const [showProdDrawer, setShowProdDrawer] = useState(false);
    const { loading, hasContent, tableList, tableMap, total, requestTableData, expandKeys } = useTableDataLoader(productApi, 'getWaimaoProductList', searchParam, innerVisible, isInMailAPage);
    const isFirstLoadingDone = useRef(false);
    const isFirstLoadingTurn = useRef(false);
    useEffect(() => {
        if (isFirstLoadingDone.current)
            return;
        if (loading && !isFirstLoadingTurn.current) {
            isFirstLoadingTurn.current = true;
            return;
        }
        if (!loading && isFirstLoadingTurn.current) {
            isFirstLoadingDone.current = true;
            onFirstLoadDone && onFirstLoadDone();
        }
    }, [loading]);
    useEffect(() => {
        setAllTableMap(Object.assign(Object.assign({}, allTableMap), tableMap));
    }, [tableMap]);
    useEffect(() => {
        if (insertGuideEditorName2 === true) {
            trackApi.track('pc_markting_edm_host_addProduct_show_2rd');
        }
    }, [insertGuideEditorName2]);
    const checkSample = () => {
        setShowSampleModal(true);
        if (insertGuideEditorName2 === true) {
            trackApi.track('pc_markting_edm_host_addProduct_action_2rd', { action: 'sample' });
        }
        if (fromProductGuide === true) {
            trackApi.track('pc_markting_edm_single_addProduct_action', { action: 'sample' });
        }
    };
    const addProductInEmail = async (tab, imgSize, langVal, imgDisplay) => {
        const info = selectedRows.map(item => ({
            productId: (item === null || item === void 0 ? void 0 : item.tempId) || (item === null || item === void 0 ? void 0 : item.id) || '',
            productType: (item === null || item === void 0 ? void 0 : item.isSPU) || (item === null || item === void 0 ? void 0 : item.id) ? 'SPU' : 'SKU',
        }));
        let links = [];
        if (!isInMailAPage) {
            links = await siteApi.getSiteLinks({
                siteOptAttrType: 'GEN_PRODUCT_DETAIL_LINK',
                productIds: selectedRowKeys,
                siteId: selectSite[0],
                businessType: businessTypeMap[fromPage],
                domain: selectSite[1],
                languageCode: langVal,
            });
        }
        else {
            links = await siteApi.getSiteLinks({
                siteOptAttrType: 'GEN_PRODUCT_DETAIL_LINK_V2',
                productIds: selectedRowKeys,
                siteId: selectSite[0],
                businessType: businessTypeMap[fromPage],
                domain: selectSite[1],
                languageCode: langVal,
                productInfoList: info,
            });
        }
        setAllTableMap((preAllTableMap) => {
            links.forEach(({ id, link }) => {
                preAllTableMap[id].productLink = link;
            });
            return preAllTableMap;
        });
        const themeColumns = [imgColumns, tableColumns, waColumns];
        if (insertGuideEditorName2 === true) {
            trackApi.track('pc_markting_edm_host_addProduct_action_2rd', { action: 'confirm' });
        }
        if (fromProductGuide === true) {
            trackApi.track('pc_markting_edm_single_addProduct_action', { action: 'confirm' });
        }
        props.onAdd(tab, selectedRowKeys.map(key => allTableMap[key]), themeColumns[tab], fieldsMap, imgSize, langVal, imgDisplay, selectSite[0], insertGuideEditorName2);
        setShowPreviewModal(false);
        setShouldInsertGuideEditorName2 && setShouldInsertGuideEditorName2(false);
    };
    const changeSelectedKeys = (val, _) => {
        const tableRows = val.map(item => allTableMap[item]);
        if (!isLimitSelectCount) {
            setSelectedRowKeys(val);
            setSelectedRows(tableRows);
        }
        else if (val.length > MAX_COUNT) {
            setSelectedRowKeys(val.slice(0, MAX_COUNT));
            setSelectedRows(tableRows.slice(0, MAX_COUNT));
            toast.error({ content: getIn18Text('BUNENGCHAOGUOXGE', { count: MAX_COUNT }) });
        }
        else {
            setSelectedRowKeys(val);
            setSelectedRows(tableRows);
        }
    };
    const changeWaSelectedKeys = (val) => {
        if (val.length > MAX_COUNT) {
            setSelectedRowKeys(val.slice(0, MAX_COUNT));
            toast.error({ content: getIn18Text('BUNENGCHAOGUOXGE', { count: MAX_COUNT }) });
        }
        else {
            setSelectedRowKeys(val);
        }
    };
    const deleteSelectedKey = (index) => {
        selectedRowKeys.splice(index, 1);
        selectedRows.splice(index, 1);
        setSelectedRows([...selectedRows]);
        setSelectedRowKeys([...selectedRowKeys]);
    };
    const onPaginationChange = (page, pageSize) => {
        setCurrentPage(page);
        setPagesize(pageSize);
        setSearchParam(Object.assign(Object.assign({}, searchParam), { page,
            pageSize }));
    };
    const onNextStep = async () => {
        const length = selectedRowKeys.length;
        if (length > 0 && length <= MAX_COUNT) {
            if (props.onNextStep) {
                setDisableResetData(true);
                props.onNextStep(selectedRowKeys.map(key => allTableMap[key]));
                resetData();
                return;
            }
            if (props.onNextStepResetdata) {
                props.onNextStepResetdata(selectedRowKeys.map(key => allTableMap[key]));
                resetData();
                return;
            }
            try {
                const siteList = await siteApi.getSiteDomainList({ isShowOuterSite: false });
                if (siteList.length > 0) {
                    siteListRef.current = siteList;
                    if (siteList.length === 1 && siteList[0].bindDomains.length <= 1)
                        setSelectSite([siteList[0].siteId]);
                }
            }
            catch (e) {
                console.error(e);
            }
            setShowPreviewModal(true);
            props.onClose();
            trackApi.track('mail_add_productsucc', { position: fromPage, quantity: length });
        }
        else {
            toast.error({ content: length > MAX_COUNT ? getIn18Text('BUNENGCHAOGUOXGE', { count: MAX_COUNT }) : getIn18Text('QINGXUANZESHANGPIN') });
        }
    };
    const onBack = () => {
        setShowPreviewModal(false);
        setDisableResetData(true);
        props.onShow();
    };
    const { resetImgColumns, resetTableColumns, resetWAColumns } = useActions(MailProductActions);
    const resetData = () => {
        if (disableResetData) {
            setDisableResetData(false);
            return;
        }
        setSearchKey('');
        setNoEmpty(false);
        setSelectedRowKeys([]);
        setSelectedRows([]);
        setCurrentPage(1);
        setPagesize(defaultPageSize);
        setSearchParam({
            keyword: '',
            page: 1,
            pageSize: defaultPageSize,
        });
        resetImgColumns();
        resetTableColumns();
        resetWAColumns();
        setImgSize(150);
        siteListRef.current = [];
        setSelectSite(['']);
    };
    const destroyModal = () => {
        setShouldInsertGuideEditorName2 && setShouldInsertGuideEditorName2(false);
        resetData();
        setShowSampleModal(false);
        setShowPreviewModal(false);
        props.onClose();
    };
    const onChange = (e) => {
        setNoEmpty(true);
        e.persist();
        setSearchKey(e.target.value);
    };
    const showAddProductUniDrawer = (onAddSuccess) => {
        showUniDrawer({
            moduleId: UniDrawerModuleId.ProductCreate,
            moduleProps: {
                visible: true,
                onClose: () => {
                    if (shouldOpenRef.current) {
                        props.onShow();
                    }
                    shouldOpenRef.current = true;
                },
                onSuccess: data => {
                    onAddSuccess && onAddSuccess();
                    shouldOpenRef.current = true;
                    onPaginationChange(1, defaultPageSize);
                    setInnerVisible(true);
                    if (data && data.id) {
                        if (selectedRowKeys.length < MAX_COUNT) {
                            setSelectedRowKeys([...selectedRowKeys, data.id]);
                            setSelectedRows([...selectedRows, data]);
                        }
                        setAllTableMap(Object.assign(Object.assign({}, tableMap), { [data.id]: data }));
                    }
                },
                topSlotDisabled: hiddenExampleEntry,
                showExample: ['BUTTON'].includes(fromPage)
                    ? undefined
                    : () => {
                        checkSample();
                    },
            },
        });
    };
    const addProduct = () => {
        if (insertGuideEditorName2 === true) {
            trackApi.track('pc_markting_edm_host_addProduct_action_2rd', { action: 'create' });
        }
        if (fromProductGuide === true) {
            trackApi.track('pc_markting_edm_single_addProduct_action', { action: 'create' });
        }
        props.onClose();
        showAddProductUniDrawer();
    };
    const addProductByUrl = () => {
        setShowProdDrawer(true);
    };
    const fetchProductListCount = async () => {
        if (props.visible) {
            const data = await productApi.getWaimaoProductList({
                keyword: '',
                page: 1,
                pageSize: 1,
            });
            if (data && data.totalCount) {
                setInnerVisible(true);
            }
            else {
                if (showTableWhenProductEmpty) {
                    setInnerVisible(true);
                }
                autoShowProductAddModal && addProduct();
                shouldOpenRef.current = false;
            }
        }
        else {
            setInnerVisible(false);
        }
    };
    useEffect(() => {
        fetchProductListCount();
    }, [props.visible]);
    useEffect(() => {
        if (innerVisible) {
            trackApi.track('product_select_view', { from_page: fromPage });
            if (insertGuideEditorName2 === true) {
                trackApi.track('pc_markting_edm_host_addProduct_action_2rd', { action: 'select' });
            }
            if (fromProductGuide === true) {
                trackApi.track('pc_markting_edm_single_addProduct_action', { action: 'select' });
            }
        }
    }, [innerVisible]);
    const isEmpty = !(hasContent || searchKey || noEmpty || showTableWhenProductEmpty);
    useEffect(() => {
        onSelectRowsChange(selectedRows);
    }, [selectedRows]);
    useImperativeHandle(props.apiRef, () => ({
        showAddProductUniDrawer,
    }));
    const getContent = () => {
        return (React.createElement(React.Fragment, null, !isEmpty ? (React.createElement("div", { className: style.content, style: Object.assign({}, contentStyle) },
            React.createElement("div", { className: style.left, style: Object.assign({}, tableContentStyle) },
                isLimitSelectCount && (React.createElement(Alert, { message: isInWAPage
                        ? '每个商品会作为一条单独的消息发送，建议不要一次选择过多商品同时发送（最多10个），以避免短时间发送大量消息导致封号'
                        : '支持选择多个商品发送，最多可选择20个商品，以保证展示和送达效果', type: "info", showIcon: true, className: style.alert })),
                React.createElement("div", { className: style.searchOuter },
                    React.createElement(Input, { className: style.search, value: searchKey, onChange: onChange, onCompositionStart: () => {
                            setIsComposition(true);
                        }, onCompositionEnd: () => {
                            setIsComposition(false);
                        }, placeholder: getIn18Text('QINGSHURUSHANGPINZHONGYING'), prefix: React.createElement(SearchIcon, null), disabled: contentDisable, allowClear: true }),
                    fromPage == 'BUTTON' || !enableCheckSample ? null : React.createElement("a", { onClick: checkSample }, getIn18Text('CHAKANSHILI'))),
                React.createElement("div", { className: style.addWrapper },
                    isInMailAPage && (React.createElement("a", { onClick: () => {
                            if (contentDisable)
                                return;
                            trackApi.track('product_select_add_click');
                            addProduct();
                        }, style: contentDisable
                            ? {
                                cursor: 'not-allowed',
                            }
                            : {} },
                        React.createElement(AddIcon, null),
                        getIn18Text('TIANJIASHANGPSDLR'))),
                    !isInMailAPage && (React.createElement("a", { onClick: () => {
                            trackApi.track('product_select_add_click');
                            addProduct();
                        } },
                        React.createElement(AddIcon, null),
                        getIn18Text('TIANJIASHANGPIN'))),
                    isInMailAPage && showAnalyzeProductByUrl && (React.createElement("a", { onClick: () => {
                            if (contentDisable)
                                return;
                            trackApi.track('product_select_add_click');
                            addProductByUrl();
                        }, style: contentDisable
                            ? {
                                cursor: 'not-allowed',
                            }
                            : {} },
                        React.createElement(LianjieIcon, null),
                        getIn18Text('TIANJIASHANGPLJJXLR'),
                        React.createElement(Tooltip, { placement: "topRight", trigger: "hover", title: getIn18Text('FUZHIALBBGJZYMXDPTDS14') },
                            React.createElement(TongyongYiwen, { wrapClassName: "wmzz", style: { color: '#6F7485', position: 'relative' } })))),
                    React.createElement("a", { className: style.lastEle, onClick: () => {
                            if (contentDisable)
                                return;
                            requestTableData();
                        }, style: contentDisable
                            ? {
                                cursor: 'not-allowed',
                            }
                            : {} },
                        React.createElement(TongyongShuaxin, { stroke: "#4C6AFF", fontSize: 16, style: { marginTop: '4px' } }),
                        getTransText('SHUAXIN'))),
                selectedRowKeys.length > 0 && showSelectedList && (React.createElement("div", { className: style.chooseProductsOuter },
                    React.createElement("div", { className: style.title }, getIn18Text('YIXUAN：')),
                    React.createElement("div", { className: classNames(style.chooseProducts, {
                            [style.notInWaPage]: isInMailAPage,
                        }) }, selectedRowKeys.map((id, index) => {
                        if (!allTableMap[id])
                            return null;
                        const name = allTableMap[id]['product_name_cn'];
                        return (React.createElement("div", { className: style.productItem, key: id },
                            React.createElement("div", { className: style.productName },
                                React.createElement(EllipsisTooltip, null, name)),
                            React.createElement(CloseSvg, { className: style.close, onClick: () => deleteSelectedKey(index) })));
                    })),
                    isInMailAPage && (React.createElement("div", { className: style.clearAll, onClick: () => {
                            setSelectedRowKeys([]);
                        } }, getIn18Text('QINGKONGYIX'))))),
                React.createElement(React.Fragment, null, isInMailAPage ? (hasContent ? (React.createElement(React.Fragment, null,
                    React.createElement(SiriusTable, { style: Object.assign({ width: onOpen ? 588 : 860 }, tableStyle), loading: loading, columns: columnslist, dataSource: tableList, pagination: false, rowKey: "tempId", rowClassName: style.rowClass, scroll: {
                            x: 'max-content',
                            y: 240,
                        }, expandable: {
                            expandedRowKeys: expandKeys,
                            defaultExpandAllRows: true,
                            childrenColumnName: 'productStockList',
                            expandIconColumnIndex: 2,
                            columnWidth: 16,
                            indentSize: 40,
                            expandedRowClassName: (record, index, indent) => {
                                return style.expandRowClass;
                            },
                            expandIcon: ({ expanded, onExpand, record }) => record.isSPU && (record === null || record === void 0 ? void 0 : record.stockLength) ? (expanded ? (React.createElement(TongyongZhankaiXia, { style: { marginRight: 8 }, wrapClassName: "wmzz", onClick: e => onExpand(record, e) })) : (React.createElement(TongyongZhankaiYou, { style: { marginRight: 8 }, wrapClassName: "wmzz", onClick: e => onExpand(record, e) }))) : null,
                            rowExpandable: (record) => {
                                return record.isSPU && (record === null || record === void 0 ? void 0 : record.stockLength);
                            },
                            onExpand(expanded, record) {
                                if (expanded) {
                                    expandKeys.push(record === null || record === void 0 ? void 0 : record.tempId);
                                }
                                else {
                                    expandKeys.splice(expandKeys.indexOf(record === null || record === void 0 ? void 0 : record.tempId), 1);
                                }
                            },
                        }, rowSelection: {
                            fixed: true,
                            checkStrictly: true,
                            selectedRowKeys,
                            preserveSelectedRowKeys: true,
                            getCheckboxProps: () => {
                                return {
                                    disabled: contentDisable ? true : false,
                                };
                            },
                            onChange(keys, selectedRows) {
                                changeSelectedKeys(keys, selectedRows);
                            },
                        } }),
                    React.createElement("div", { className: style.tablePagination }, total > 10 ? (React.createElement(SiriusPagination, { showTotal: _total => `共${_total}条数据`, current: currentPage, pageSize: pagesize, total: total, onChange: onPaginationChange, pageSizeOptions: ['20', '50', '100'] })) : null))) : (React.createElement(EmptyList, { isCustoms: true, className: style.emptyList, style: Object.assign({ width: onOpen ? 588 : 860 }, emptyStyle) },
                    React.createElement("div", null, emptyText)))) : null),
                React.createElement(React.Fragment, null, !isInMailAPage ? (hasContent ? (React.createElement(React.Fragment, null,
                    React.createElement(SiriusTable, { style: { width: onOpen ? 588 : 860 }, loading: loading, columns: columnslist, dataSource: tableList, pagination: false, rowKey: "id", scroll: { y: 248 }, rowSelection: {
                            selectedRowKeys,
                            getCheckboxProps: (record) => ({
                                disabled: selectedRowKeys.length >= MAX_COUNT && !selectedRowKeys.includes(record.id),
                            }),
                            preserveSelectedRowKeys: true,
                            onChange(keys) {
                                changeWaSelectedKeys(keys);
                            },
                        } }),
                    React.createElement("div", { className: style.tablePagination }, total > 10 ? (React.createElement(SiriusPagination, { showTotal: _total => `共${_total}条数据`, current: currentPage, pageSize: pagesize, total: total, onChange: onPaginationChange, pageSizeOptions: ['20', '50', '100'] })) : null))) : (React.createElement(EmptyList, { isCustoms: true, className: style.emptyList, style: { width: onOpen ? 588 : 860 } },
                    React.createElement("div", null, getIn18Text('ZANWEIZHAODAOSOUSUONEI'))))) : null)),
            showSidebarGuideCompment && React.createElement(SidebarGuideCompment, { type: ContentProduct, setOnOpen: setOnOpen }))) : loading ? (React.createElement(Spin, { tip: getIn18Text('JIAZAIZHONG..'), indicator: React.createElement(LoadingOutlined, { spin: true, style: { fontSize: 24 } }), style: { maxHeight: 480 } },
            React.createElement("div", { style: { height: 480 } }))) : (React.createElement(ProductEmpty, { onClose: destroyModal }))));
    };
    return (React.createElement(ConfigProvider, { locale: zhCN },
        innerVisible ? (inModal ? (React.createElement(SiriusModal, { title: isEmpty && !loading ? null : props.onNextStep || props.onNextStepResetdata ? (getIn18Text('XUANZESHANGPIN')) : (React.createElement("div", { className: style.productSteps },
                React.createElement("div", { className: style.productStepsDot, style: { borderColor: '#4C6AFF', background: '#4C6AFF' } }),
                React.createElement("div", { style: { color: '#272E47' } }, getIn18Text('XUANZESHANGPIN')),
                React.createElement("div", { className: style.productStepsLine }),
                React.createElement("div", { className: style.productStepsDot }),
                React.createElement("div", null, getIn18Text('QUERENSHANGPINYANGSHI')))), width: 916, visible: innerVisible, className: style.productSettingModal, onOk: onNextStep, onCancel: destroyModal, okText: props.onNextStep || props.onNextStepResetdata ? getIn18Text('QUEDING') : getIn18Text('XIAYIBU'), maskClosable: false, getContainer: getContainer, footer: isEmpty ? null : undefined }, getContent())) : (React.createElement("div", { className: style.productSettingModal }, getContent()))) : null,
        React.createElement(ProductSampleModal, { fromPage: fromPage, visible: showSampleModal, onClose: () => setShowSampleModal(false) }),
        React.createElement(ProductPreviewModal, { fromPage: fromPage, fieldsMap: fieldsMap, onBack: onBack, onAdd: addProductInEmail, selectedRowKeys: selectedRowKeys, selectedRows: selectedRows, tableMap: allTableMap, siteList: siteListRef.current, selectSite: selectSite, setSelectSite: setSelectSite, visible: showPreviewModal, onClose: () => {
                setShouldInsertGuideEditorName2 && setShouldInsertGuideEditorName2(false);
                setShowPreviewModal(false);
            }, afterClose: resetData, imgSize: imgSize, setImgSize: setImgSize, imgDisplay: imgDisplay, setImgDisplay: setImgDisplay }),
        React.createElement(SiriusProductLinkImportDrawer, { open: showProdDrawer, saveBtnText: "\u5F55\u5165\u672C\u5730\u5546\u54C1", onCancel: () => {
                setShowProdDrawer(false);
            }, onSuccess: () => {
                setShowProdDrawer(false);
            } })));
};
